export const removeStartingSlash = imagePath => {
    if (imagePath?.startsWith('/')) {
      return imagePath?.slice(1)
    } else {
      return imagePath
    }
  }
  